import React, { useState } from "react";
import Layout from "../layout/Layout";
import { Col, Row } from "react-bootstrap";
import CustomFormInput from "../components/CustomFormInput";
import { decryptFromStoreLoc, encryptAndStoreLoc } from "../helper/localStorage";
import { profileValidate } from "../validate/profile";
import ErrorFilter from "../helper/errorFilter";
import { requestHandler } from "../helper";
import { updateProfile } from "../controller";
import { toast } from "react-toastify";
import SingleError from "../helper/SingleError";
import Loader from "../components/Loader";

function Profile() {

  const [firstName, setFirstName] = useState(decryptFromStoreLoc("firstName") || "");
  const [lastName, setLastName] = useState(decryptFromStoreLoc("lastName") || "");
  const [selectedFile, setSelectedFile] = useState(decryptFromStoreLoc("imageURL") || null);
  const email = decryptFromStoreLoc("email");
  const role = decryptFromStoreLoc("role");
  const [errors, setErrors] = useState({});
  const [submitCount, setSubmitCount] = useState(0);
  const requiredFields = ["firstName", "lastName"];
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;


  const handleSubmit = async () => {
    setSubmitCount(prevCount => prevCount + 1);
    const updatedValues = { firstName, lastName };
    let validationErrors = profileValidate(updatedValues);
    validationErrors = ErrorFilter(validationErrors, requiredFields);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {

      const formData = new FormData();
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);

      if (selectedFile) {
        formData.append("profile_image", selectedFile);
      }
      await requestHandler(async () => await updateProfile(formData),
        setLoading,
        (res) => {
          toast.success(res.message);
          encryptAndStoreLoc("firstName", res.data.firstName);
          encryptAndStoreLoc("lastName", res.data.lastName);
          encryptAndStoreLoc("imageURL", res.data.imageURL);
        }, () => { });
    }
  }

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    if (submitCount > 0) {
      let validationErrors = profileValidate({ firstName, lastName, [name]: value });
      validationErrors = ErrorFilter(validationErrors, requiredFields);
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        delete errors[name];
      }
    }
    if (files) {
      const file = files[0];
      if (file) {
        setSelectedFile(file);
      }
    }
    if (name === "firstName") {
      setFirstName(value);
    } else if (name === "lastName") {
      setLastName(value);
    }
  }
  return (
    <>
      {loading && <Loader />}
      <Layout>
        <div className="card-wrapper">
          <div className="card-body">
            <Row className='justify-content-center py-md-5'>
              <Col xxl={4} xl={5} md={6} sm={8}>
                <div className="d-flex justify-content-center mb-3">
                  <label htmlFor="imgUpload">
                    <div className="profile-upload">
                      <img
                        src={selectedFile?.name ? URL.createObjectURL(selectedFile) : baseUrl + selectedFile}
                        // src={imageSrc}
                        className="img-fluid w-100 h-100 rounded-circle object-fit-cover"
                        alt="user"
                      />
                      <input type="file" id="imgUpload" onChange={handleChange} />
                      <div className="upload-icon">
                        <img src="/images/svg/edit.svg" alt="icon" />
                      </div>
                    </div>
                  </label>
                </div>
                <CustomFormInput
                  type="text"
                  label="First Name"
                  placeholder="Enter first name"
                  id="firstName"
                  name="firstName"
                  value={firstName}
                  onChange={handleChange}
                />
                <SingleError error={errors?.firstName} />
                <CustomFormInput
                  type="text"
                  label="Last Name"
                  placeholder="Enter last name"
                  id="lastName"
                  name="lastName"
                  value={lastName}
                  onChange={handleChange}
                />
                <SingleError error={errors?.lastName} />
                <CustomFormInput
                  type="email"
                  label="Email"
                  placeholder="Enter email"
                  id="email"
                  value={email}
                  disabled
                />
                <CustomFormInput
                  style={{ textTransform: "capitalize" }}
                  type="text"
                  label="Role"
                  placeholder="Enter role"
                  id="role"
                  value={role}
                  disabled
                />
                <button className="btn btn-primary w-100" type="button" onClick={handleSubmit}>Save</button>
              </Col>
            </Row>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default Profile